<template>
  <el-dialog :title="$t('couponManage.editCoupon')" :visible.sync="dialogVisible" width="70%"
    @close="handleClose">
    <el-form ref="form" :model="editCouponInfo" label-width="120px">
      <el-form-item :label="$t('couponManage.couponCode')">
        <el-input v-model="editCouponInfo.couponCode" disabled />
      </el-form-item>

      <el-form-item :label="$t('couponManage.couponName')"
        :rules="[{ required: true, message: $t('couponManage.couponNameRequired'), trigger: 'blur' }]">
        <el-input v-model="editCouponInfo.couponName"
          :placeholder="$t('couponManage.couponNameRequired')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.couponType')">
        <el-select v-model="editCouponInfo.couponType" :placeholder="$t('couponManage.couponTypeRequired')"
          style="width:100%" @change="_changeCouponType">
          <el-option :label="$t('couponManage.fullReduction')" value="01" />
          <el-option :label="$t('couponManage.discount')" value="02" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="editCouponInfo.couponType === '01'" :label="$t('couponManage.discountAmount')"
        :rules="[{ required: true, message: $t('couponManage.discountAmountRequired'), trigger: 'blur' }]">
        <el-input v-model="editCouponInfo.discountAmount" type="number"
          :placeholder="$t('couponManage.discountAmountRequired')" />
      </el-form-item>

      <el-form-item v-if="editCouponInfo.couponType === '02'" :label="$t('couponManage.discountPercent')"
        :rules="[{ required: true, message: $t('couponManage.discountPercentRequired'), trigger: 'blur' }]">
        <el-input v-model="editCouponInfo.discountPercent" type="number"
          :placeholder="$t('couponManage.discountPercentRequired')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.minAmount')">
        <el-input v-model="editCouponInfo.minAmount" type="number"
          :placeholder="$t('couponManage.minAmountPlaceholder')" />
      </el-form-item>

      <el-form-item v-if="editCouponInfo.couponType === '02'" :label="$t('couponManage.maxDiscount')">
        <el-input v-model="editCouponInfo.maxDiscount" type="number"
          :placeholder="$t('couponManage.maxDiscountPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.description')">
        <el-input v-model="editCouponInfo.description" type="textarea"
          :placeholder="$t('couponManage.descriptionPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.totalQuantity')"
        :rules="[{ required: true, message: $t('couponManage.totalQuantityRequired'), trigger: 'blur' }]">
        <el-input v-model="editCouponInfo.totalQuantity" type="number"
          :placeholder="$t('couponManage.totalQuantityRequired')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.limitPerUser')">
        <el-input v-model="editCouponInfo.limitPerUser" type="number"
          :placeholder="$t('couponManage.limitPerUserPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.issueType')"
        :rules="[{ required: true, message: $t('couponManage.issueTypeRequired'), trigger: 'change' }]">
        <el-select v-model="editCouponInfo.issueType" :placeholder="$t('couponManage.issueTypeRequired')"
          style="width:100%">
          <el-option :label="$t('couponManage.userReceive')" value="01" />
          <el-option :label="$t('couponManage.shopGive')" value="02" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('couponManage.validDays')">
        <el-input v-model="editCouponInfo.validDays" type="number"
          :placeholder="$t('couponManage.validDaysPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.startTime')">
        <el-date-picker v-model="editCouponInfo.startTime" type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('couponManage.startTimePlaceholder')" style="width:100%" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.endTime')">
        <el-date-picker v-model="editCouponInfo.endTime" type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('couponManage.endTimePlaceholder')" style="width:100%" />
      </el-form-item>

      <el-form-item :label="$t('couponManage.status')">
        <el-select v-model="editCouponInfo.statusCd" :placeholder="$t('couponManage.selectStatus')"
          style="width:100%">
          <el-option :label="$t('couponManage.inUse')" value="0" />
          <el-option :label="$t('couponManage.invalid')" value="1" />
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="updateCouponInfo">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateShopCoupon } from '@/api/coupon/couponApi'

export default {
  name: 'EditShopCoupon',
  data() {
    return {
      dialogVisible: false,
      editCouponInfo: {}
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.editCouponInfo = { ...row }
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.editCouponInfo = {}
    },
    _changeCouponType() {
      // 切换优惠类型时清空相关字段
      if (this.editCouponInfo.couponType === '01') {
        this.editCouponInfo.discountPercent = ''
        this.editCouponInfo.maxDiscount = ''
      } else {
        this.editCouponInfo.discountAmount = ''
      }
    },
    async updateCouponInfo() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            await updateShopCoupon(this.editCouponInfo)
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          }
        })
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>

